import styled from "@emotion/styled";
import { formLabelColorTheme } from "./formLabelColorTheme";
export const FormLabelIcon = styled("div")`
    display: flex;
    color: ${_ref => {
  let {
    themeMode,
    validationState
  } = _ref;
  return formLabelColorTheme.color[validationState](themeMode);
}};
`;
//# sourceMappingURL=FormLabelIcon.js.map